// EventStepFriendly.tsx
import React, { useEffect, useState } from 'react';
import { EventDataMap, FriendlyEventData } from '../../../types/EventTypes';

interface Props {
  onNext: (data: EventDataMap['friendly']) => void;
  onBack: () => void;
  initialData?: EventDataMap['friendly'];
}

const EventStepFriendly: React.FC<Props> = ({
  onNext,
  onBack,
  initialData,
}) => {
  const [formData, setFormData] = useState<FriendlyEventData>({
    opponent: initialData?.opponent || '',
    referee: {
      name: initialData?.referee?.name || '',
      email: initialData?.referee?.email || '',
      phone: initialData?.referee?.phone || '',
    },
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name.startsWith('referee.')) {
      const field = name.split('.')[1];
      setFormData(prev => ({
        ...prev,
        referee: {
          ...prev.referee,
          [field]: value,
        },
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onNext(formData);
  };

  return (
    <form onSubmit={handleSubmit} className='space-y-4'>
      <h2 className='text-xl font-bold'>Step 2: Friendly Match Info</h2>

      <label className='block'>
        <span className='text-sm font-medium'>Opponent</span>
        <input
          type='text'
          name='opponent'
          value={formData.opponent}
          onChange={handleChange}
          required
          className='p-2 border rounded w-full'
        />
      </label>

      <fieldset className='space-y-2'>
        <legend className='text-sm font-semibold'>Referee Details</legend>

        <input
          type='text'
          name='referee.name'
          placeholder='Full Name'
          value={formData.referee.name}
          onChange={handleChange}
          className='p-2 border rounded w-full'
        />

        <input
          type='email'
          name='referee.email'
          placeholder='Email Address'
          value={formData.referee.email}
          onChange={handleChange}
          className='p-2 border rounded w-full'
        />

        <input
          type='tel'
          name='referee.phone'
          placeholder='Mobile Number'
          value={formData.referee.phone}
          onChange={handleChange}
          className='p-2 border rounded w-full'
        />
      </fieldset>

      <div className='flex justify-between'>
        <button
          type='button'
          onClick={onBack}
          className='px-4 py-2 bg-gray-400 text-white rounded'
        >
          Back
        </button>
        <button
          type='submit'
          className='px-4 py-2 bg-blue-600 text-white rounded'
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default EventStepFriendly;
